import React, { useState } from "react";
import "./PerformanceByYear.scss";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const PerformanceByYear = () => {
  const { t } = useTranslation();
  const yearContent = t("trackRecord.year.content", { returnObjects: true }) as { title: string; list: string[] }[];
  const [cardActive, setCardActive] = useState(Array.from({ length: yearContent.length }, () => false));

  const handleList = (e: React.MouseEvent<HTMLDivElement>) => {
    const id = Number(e.currentTarget.id);
    const newCard = [...cardActive];
    newCard[id] = !newCard[id];
    setCardActive(newCard);
  };
  return (
    <>
      <Seo title={t("trackRecord.year.seo.title")} description={t("trackRecord.year.seo.des")} path="projects/yearly" />
      <div className="performance_by_year_wrap">
        <h2 className="title_wrap">{t("trackRecord.year.title")}</h2>
        <div className="contents_wrap">
          {yearContent.map((content: { title: string; list: string[] }, index: number) => {
            return (
              <ul key={`${content.title}_${index}`}>
                <div className="name_wrap" id={`${index}`} onClick={handleList}>
                  <div className="name">{content.title}</div>
                  <button>
                    <img src="/imgs/arrow.png" alt="arrow" />
                  </button>
                </div>
                <div className={`list ${cardActive[index] ? "open" : ""}`}>
                  {content.list.map((text: string, index: number) => {
                    return <li key={`${text}_${index}`}>{text}</li>;
                  })}
                </div>
              </ul>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default PerformanceByYear;
